import React from 'react';

const LocationStateContext = React.createContext();
const LocationSetStateContext = React.createContext();

export const LocationStateContextProvider = ({ children, initialValue }) => {
    const [state, setState] = React.useState(initialValue);

    return (
        <LocationSetStateContext.Provider value={setState}>
            <LocationStateContext.Provider value={state}>{children}</LocationStateContext.Provider>
        </LocationSetStateContext.Provider>
    );
};

export const useLocationSetStateContext = () => {
    const context = React.useContext(LocationSetStateContext);

    if (context == null) {
        throw new Error(
            `'useLocationSetStateContext' needs to be within 'LocationSetStateContext'`,
        );
    }

    return context;
};

export const useLocationStateContext = () => {
    const context = React.useContext(LocationStateContext);

    if (context == null) {
        throw new Error(`'useLocationStateContext' needs to be within 'LocationStateContext'`);
    }

    return context;
};
